import { getSessionToken } from "./lib/sessionToken";

// API Configuration
// If REACT_APP_BASE_URL is empty, it will use relative paths (works with reverse proxy)
// If it's set, it will use that absolute URL
// export const API_BASE_URL = '';
// export const API_BASE_URL = process.env.REACT_APP_BASE_URL || 'http://localhost:8000'; // this was used in development (prod version seems to work in local environment)
// API Configuration
// Use empty string in development to leverage proxy, 
// export const API_BASE_URL = process.env.REACT_APP_BASE_URL || 
//   (process.env.NODE_ENV === 'development' ? '' : 'http://localhost:8000');
// I think everything above is irrelevant - after configuring docker-compose - 5/8/26

/**
 * Normalize public origin for API requests (no trailing slash).
 * Uses REACT_APP_BASE_URL.
 * Empty string: same-origin relative paths (CRA dev proxy or nginx reverse proxy).
 */
function normalizePublicBaseUrl() {
  const raw = (
    process.env.REACT_APP_BASE_URL ||
    ""
  ).trim();
  if (!raw) {
    return "";
  }

  const normalized = raw.replace(/\/$/, "");
  
  // safeguard to prevent mixed-content in production if env accidentally uses http://
  try {
    const parsed = new URL(normalized);
    // Prevent mixed-content in production if env accidentally uses http://.
    if (typeof window !== "undefined" && window.location.protocol === "https:" && parsed.protocol === "http:") {
      parsed.protocol = "https:";
      return parsed.toString().replace(/\/$/, "");
    }
  } catch {
    console.warn("Invalid REACT_APP_BASE_URL; using raw value.");
  }

  return normalized;
}

export const API_BASE_URL = normalizePublicBaseUrl();

/**
 * Builds a ws:// or wss:// URL for a path such as `/ws/chat/1/`.
 *
 * When REACT_APP_BASE_URL is set, uses that host and picks
 * ws vs wss from the HTTP scheme. When unset (empty), uses `window.location`
 * so CRA dev proxy / same-origin deployments work.
 *
 * Local Docker caveat: CRA on :3000 does not complete Channels upgrades on `/ws`
 * (webpack-dev-server). Prefer nginx on :80 for those sockets.
 *
 * @param {string} path - Absolute path beginning with /
 * @returns {string}
 */
/**
 * Append the session token so websocket auth can see it.
 * Browsers cannot set an Authorization header on a WebSocket.
 * @param {string} url
 * @returns {string}
 */
function withSessionToken(url) {
  const token = getSessionToken();
  if (!token || url.includes("token=")) {
    return url;
  }
  const join = url.includes("?") ? "&" : "?";
  return `${url}${join}token=${encodeURIComponent(token)}`;
}

export function getWebSocketUrl(path) {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  const base = API_BASE_URL;

  if (base) {
    try {
      const url = new URL(base);
      const wsProto = url.protocol === "https:" ? "wss:" : "ws:";
      return withSessionToken(`${wsProto}//${url.host}${normalizedPath}`);
    } catch {
      console.warn("Invalid REACT_APP_BASE_URL; check config.");
    }
  }

  if (typeof window !== "undefined") {
    const wsProto = window.location.protocol === "https:" ? "wss:" : "ws:";
    const { hostname, port } = window.location;
    // CRA :3000 cannot proxy Channels WS reliably — use nginx (:80) in local docker.
    if (
      (port === "3000" || port === "3001") &&
      (hostname === "localhost" || hostname === "127.0.0.1")
    ) {
      return withSessionToken(`${wsProto}//${hostname}${normalizedPath}`);
    }
    return withSessionToken(`${wsProto}//${window.location.host}${normalizedPath}`);
  }

  return withSessionToken(`ws://127.0.0.1:8000${normalizedPath}`);
}
